var ChartsPlugin = require('utils/charts/charts_plugin');
var ChartsAutoRefresh = ChartsPlugin.extend({
    lastReloadTriggered: 0,
    autoReloadDisabled: true,
    btnToggle: undefined,
    btnRefresh: undefined,
    currentReloadTime: undefined,
    expectedTriggerSecs: undefined,
    initPlugin: function (options) {
        var self = this;
        this.view.on('charts:period:set', function () {
            self.updateAutoRefresh();
        });

        this.btnToggle = $(this.view.el).find('.js-chart-auto-refresh');
        this.btnRefresh = $(this.view.el).find('.js-chart-refresh');

        this.btnToggle.on('click', function () {
            self.autoReloadDisabled = !self.autoReloadDisabled;
            self.updateAutoRefreshButtonState();
        });

        this.btnRefresh.on('click', function () {
            self.view.setPeriod(
                self.view.selectedPeriod.moved ? self.view.selectedPeriod.name : undefined,
                undefined,
                self.view.selectedPeriod.free
            );
        });

        this.chartView.on('charts:draw:after', function () {
            self.toggleEnabled();
        });

        this.updateAutoRefresh();
        this.toggleEnabled();
    },

    toggleEnabled: function () {
        $(this.btnToggle).attr('disabled', this.data.isEmpty() || !this.view.selectedPeriod.reload ? 'true' : null);
        this.view.removeDisabledTooltips();
    },

    updateAutoRefresh: function () {
        this.currentReloadTime = this.view.selectedPeriod.reload;
        this.btnToggle.attr('disabled', this.view.selectedPeriod.reload ? null : true);
        this.updateAutoRefreshButtonState();
        this.scheduleAutoRefresh();
    },

    updateAutoRefreshButtonState: function () {
        if (this.view.selectedPeriod.reload && !this.autoReloadDisabled) {
            this.btnToggle.addClass('btn-selected');
            this.btnToggle.removeClass('btn-primary');
        } else {
            this.btnToggle.addClass('btn-primary');
            this.btnToggle.removeClass('btn-selected');
        }
        this.scheduleAutoRefresh();
    },

    scheduleAutoRefresh: function (secs) {
        var self = this;
        if (this.autoReloadDisabled) return;

        if (secs === undefined) {
            secs = this.currentReloadTime;
        }

        var currentSecs = new Date().getTime() / 1000;
        if (this.expectedTriggerSecs > currentSecs + secs) return;

        if (this.currentReloadTime) {
            this.expectedTriggerSecs = currentSecs + secs;
            setTimeout(function () {
                self.autoRefresh();
            }, secs * 1000);
        }
    },

    autoRefresh: function () {
        if (!this.currentReloadTime) return;
        if (this.autoReloadDisabled) return;

        var currentTime = new Date().getTime();
        var difference = (currentTime - this.lastReloadTriggered) / 1000;
        if (difference < this.currentReloadTime) {
            this.scheduleAutoRefresh(this.currentReloadTime - difference);
            return;
        }

        this.lastReloadTriggered = new Date().getTime();

        if (this.view.selectedPeriod.moved) {
            this.scheduleAutoRefresh();
            return;
        }

        this.view.setPeriod(undefined, true);
    },
});

module.exports = ChartsAutoRefresh;
